import { gql } from '../__generated__/gql';

const GET_LOCATIONS = gql(`
  query Locations(
    $orderBy: [LocationOrderByWithRelationInput!]
    $skip: Int
    $take: Int
    $where: LocationWhereInput
  ) {
    locations(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
      ...LocationTableFields
    }
  }
`);

export default GET_LOCATIONS;
